<template>
  <div>
    <c-table ref="table" title="화학자재 > 구성물질 > 규제항목 정량값" gridHeight="780px" :columns="grid.columns" :data="grid.data" :merge="grid.merge" :columnSetting="false" :isFullScreen="false" :isExcelDown="false" :filtering="false" :usePaging="false"> </c-table>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'chemQuantity',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: '',
        plantCd: '',
      }),
    },
    searchFlag: {
      type: Object,
      default: () => ({
        chemMsds: '',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return 'auto';
      },
    },
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'mdmChemId' },
          { index: 1, colName: 'mdmChemId' },
        ],
        columns: [
          {
            fix: true,
            name: 'chemNmEn',
            field: 'chemNmEn',
            label: '구성물질명',
            align: 'left',
            style: 'width:100px',
            sortable: true,
          },
          {
            fix: true,
            name: 'casNo',
            field: 'casNo',
            label: 'CAS No.',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            fix: true,
            name: 'regulationBillName',
            field: 'regulationBillName',
            label: '법규',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            fix: true,
            name: 'regulatedItemName',
            field: 'regulatedItemName',
            label: '규제항목',
            align: 'left',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'regul',
            field: 'regul',
            label: '정량값',
            child: [
              {
                name: 'appliStandSign',
                field: 'appliStandSign',
                label: '부등호',
                align: 'center',
                sortable: false,
                style: 'width:50px',
              },
              {
                name: 'appliStandQuantity',
                field: 'appliStandQuantity',
                label: '정량값',
                align: 'right',
                style: 'width:70px',
                sortable: true,
              },
            ],
          },
          {
            name: 'regul',
            field: 'regul',
            label: '규정수량',
            child: [
              {
                name: 'regulationQuantityDose',
                field: 'regulationQuantityDose',
                label: '규정수량',
                align: 'right',
                sortable: false,
                style: 'width:80px',
              },
              {
                name: 'regulationQuantityUnit',
                field: 'regulationQuantityUnit',
                label: '단위',
                align: 'center',
                sortable: false,
                style: 'width:50px',
              },
            ],
          },
          {
            label: '배출량조사대상물질 (PRTR 정량값)',
            align: 'center',
            child: [
              {
                name: 'prtrGroupId',
                field: 'prtrGroupId',
                label: '그룹',
                align: 'center',
                sortable: true,
                style: 'width:60px',
              },
              {
                name: 'prtrSwcsWtQuantity',
                field: 'prtrSwcsWtQuantity',
                label: '함유량(%)',
                align: 'right',
                sortable: true,
                style: 'width:90px',
              },
              {
                name: 'prtrSwcsTonQuantity',
                field: 'prtrSwcsTonQuantity',
                label: '취급량(톤/년)',
                align: 'right',
                sortable: true,
                style: 'width:90px',
              },
            ],
          },
          {
            label: '노출기준',
            align: 'center',
            child: [
              {
                name: 'twaPpm',
                field: 'twaPpm',
                label: 'TWA<br>(ppm)',
                align: 'right',
                sortable: true,
                style: 'width:80px',
              },
              {
                name: 'twaMm',
                field: 'twaMm',
                label: 'TWA<br>(mg/m3)',
                align: 'right',
                sortable: true,
                style: 'width:80px',
              },
              {
                name: 'stelPpm',
                field: 'stelPpm',
                label: 'STEL<br>(ppm)',
                align: 'right',
                sortable: true,
                style: 'width:80px',
              },
              {
                name: 'stelMm',
                field: 'stelMm',
                label: 'STEL<br>(mg/m3)',
                align: 'right',
                sortable: true,
                style: 'width:80px',
              },
            ],
          },
          {
            name: 'danger',
            field: 'danger',
            label: '위험물(지정수량)',
            child: [
              {
                name: 'dangerousProp',
                field: 'dangerousProp',
                label: '성질',
                align: 'left',
                style: 'width: 100px',
              },
              {
                name: 'dangerousName',
                field: 'dangerousName',
                label: '품명',
                align: 'left',
                sortable: false,
                style: 'width:100px',
              },
              {
                name: 'designatedQuantityDose',
                field: 'designatedQuantityDose',
                label: '정량값',
                align: 'right',
                sortable: false,
                style: 'width:80px',
              },
              {
                name: 'designatedQuantityUnit',
                field: 'designatedQuantityUnit',
                label: '단위',
                align: 'center',
                sortable: false,
                style: 'width:50px',
              },
              {
                name: 'designatedQuantityRemark',
                field: 'designatedQuantityRemark',
                label: '내용',
                align: 'left',
                sortable: false,
                style: 'width:200px',
              },
            ],
          },
        ],
        data: [],
      },
      editable: true,
      isSave: false,
      listUrl: '',
      saveUrl: '',
    };
  },
  computed: {
    gridHeight() {
      return this.contentHeight ? String(this.contentHeight - 200) + 'px' : '500px';
    },
  },
  watch: {
    'searchFlag.chemMsds'() {
      this.getList();
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.mam.chem.quantity.list.url;
      this.saveUrl = transactionConfig.mdm.mam.chem.quantity.save.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        mdmChemMaterialId: this.popupParam.mdmChemMaterialId,
      };
      this.$http.request(_result => {
        this.grid.data = _result.data;
      });
    },

    // saveQuantity() {
    //   if (this.$comm.validTable(this.grid.columns, this.grid.data)) {
    //     window.getApp.$emit("CONFIRM", {
    //       title: "LBLCONFIRM",
    //       message: "MSGSAVE", // 저장하시겠습니까?
    //       // TODO : 필요시 추가하세요.
    //       type: "info", // success / info / warning / error
    //       // 확인 callback 함수
    //       confirmCallback: () => {
    //         this.isSave = !this.isSave;
    //       },
    //       // 취소 callback 함수
    //       cancelCallback: () => {},
    //     });
    //   }
    // },
    // saveQuantityCallback() {
    //   window.getApp.$emit("APP_REQUEST_SUCCESS");
    //   this.getList();
    // },
  },
};
</script>
<style>
.lawspan {
  color: #0072c6 !important;
  font-size: 13px !important;
  font-weight: 600;
}
.divchklaw {
  margin-bottom: 10px;
}
</style>
